import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import Dashboard from './dashboard';

import Users from './users';

import withAdminLayout from '../../layout/withAdminLayout';

const Components = lazy(() => import('./components'));
const Task = lazy(() => import('../../container/task/Index'));

const ToDo = lazy(() => import('../../container/toDo/ToDo'));

const VideoSource = lazy(() => import('./videosource'));

const Myprofile = lazy(() => import('../../container/profile/myProfile/Index'));
const Settings = lazy(() => import('../../container/profile/settings/Settings'));

const NotFound = lazy(() => import('../../container/pages/404'));
const EventsDetails = lazy(() => import('../../container/dashboard/EventsDetails'));

const Admin = React.memo(() => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route index path="/*" element={<Dashboard />} />
        <Route path="eventsDetails/:id/*" element={<EventsDetails />} />
        <Route path="components/*" element={<Components />} />

        <Route path="app/task/*" element={<Task />} />
        <Route path="users/*" element={<Users />} />

        <Route path="app/to-do" element={<ToDo />} />
        <Route path="app/inactive-list" element={<ToDo />} />

        <Route path="videoSource/*" element={<VideoSource />} />

        <Route path="profile/myProfile/*" element={<Myprofile />} />
        <Route path="profile/*" element={<Settings />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Admin);
